import {
  CircleQuestionResponse,
  CIRCLES_ZERO,
  CirclesResponse,
} from "@/types/circle"
import { authenticatedApi } from "./client"

export const createCircle = async (name: string) => {
  try {
    await authenticatedApi.post("/circle", { name })
  } catch (error) {
    console.error("Error creating circle:", error)
  }
}

export const getCircles = async (): Promise<CirclesResponse> => {
  try {
    const response = await authenticatedApi.get<CirclesResponse>("/circles/")
    return response.data
  } catch (error) {
    console.error("Error fetching circles:", error)
    return CIRCLES_ZERO
  }
}

export const getCircleQuestions = async (
  circleId: string,
  quest_id: string | null,
): Promise<CircleQuestionResponse> => {
  try {
    const url_filter = quest_id ? `?quest_id=${quest_id}` : ""
    const response = await authenticatedApi.get<CircleQuestionResponse>(
      `/circle/${circleId}/questions${url_filter}`,
    )
    return response.data
  } catch (error) {
    console.error("Error fetching circle questions:", error)
    return []
  }
}

export const patchUserName = async (fullName: string) => {
  try {
    const response = await authenticatedApi.patch(`/user`, {
      full_name: fullName,
    })
    return response.data
  } catch (error) {
    console.error("Error updating user name:", error)
    throw error
  }
}

export const patchWantsNews = async (wants_news: boolean) => {
  try {
    const response = await authenticatedApi.patch(`/user`, { wants_news })
    return response.data
  } catch (error) {
    console.error("Error updating wants_news:", error)
    throw error
  }
}

export const patchWantsQuestProgress = async (
  wants_quest_progress: boolean,
) => {
  try {
    const response = await authenticatedApi.patch(`/user`, {
      wants_quest_progress,
    })
    return response.data
  } catch (error) {
    console.error("Error updating wants_quest_progress:", error)
    throw error
  }
}

export const patchWantsReminders = async (wants_reminders: boolean) => {
  try {
    const response = await authenticatedApi.patch(`/user`, { wants_reminders })
    return response.data
  } catch (error) {
    console.error("Error updating wants_reminders:", error)
    throw error
  }
}

export const patchUserEmail = async (email: string, profileId: string) => {
  try {
    const response = await authenticatedApi.patch(`/user/${profileId}/email`, {
      email,
    })
    return response.data
  } catch (error) {
    console.error("Error updating user email:", error)
    throw error
  }
}

export const patchUserPassword = async (
  old_password: string,
  new_password: string,
  profileId: string,
) => {
  try {
    const response = await authenticatedApi.patch(
      `/user/${profileId}/password`,
      {
        old_password,
        new_password,
      },
    )

    if (!response.data || !response.data.key) {
      console.error(
        "Unexpected response structure from password changd:",
        response.data,
      )
    }

    return response.data.key
  } catch (error) {
    console.error("Error updating user password:", error)
    throw error
  }
}

export const deleteUserAccount = async () => {
  try {
    await authenticatedApi.delete("/user")
  } catch (error) {
    console.error("Error deleting user account:", error)
    throw error
  }
}
